<script>
    import { t } from '$lib/i18n.js';
</script>

<img class="waves" src="https://assets.auting.it/images/waves/app/wave-top.svg" alt="Wave Top" />
<section>
    <div class="row">
        <div class="col mockup desktop-only">
            <img src="https://assets.auting.it/images/hand_phone.webp" alt="Mobile App Mockup" id="mockup"/>
        </div>
        <div class="col">
            <p>{$t('components.mobile_app.subtitle')}</p>
            <h2>{$t('components.mobile_app.title')}</h2>
            <h2 class="accent">{$t('components.mobile_app.title_accent')}</h2>
            <div class="stores">
                <a href="https://itunes.apple.com/it/app/auting/id1447229186" aria-label="Download on the App Store">
                    <img src="https://assets.auting.it/images/stores/app_store/dark.svg" alt="Download on the App Store" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=it.auting.auting" aria-label="Get it on Google Play">
                    <img src="https://assets.auting.it/images/stores/google_play.png" alt="Get it on Google Play" />
                </a>
            </div>
        </div>
        <div class="col mockup mobile-only">
            <img src="https://assets.auting.it/images/hand_phone.webp" alt="Mobile App Mockup" id="mockup" style="mix-blend-mode: darken;" class="mobile-only"/>
        </div>
    </div>
    <img class="waves" id="bottom-wave" src="https://assets.auting.it/images/waves/app/wave-bottom.svg" alt="Wave Bottom" />

</section>

<style>
    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 100px;
        padding-bottom: 24px;
        gap: 24px;
        background-color: var(--surface-container);
        position: relative;
    }

    .row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 40px;
        max-width: var(--max-width);
        width: 100%;
        margin: 0 auto;
    }

    .col {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 8px;
        width: 100%;
        flex: 1;
        z-index: 1;
    }

    .col.mockup {
        align-items: center;
        margin-bottom: 24px;
    }

    p {
        color: var(--on-surface);
        line-height: 1.5;
        margin: 0;
        text-align: left;
    }

    h2 {
        color: var(--on-surface);
        font-family: var(--font-body);
        text-align: left;
        margin: 0;
        padding: 0;
    }

    h2.accent {
        color: var(--orange);
        font-family: var(--font-heading);
        text-align: left;
        margin: 0;
        padding: 0;
    }

    #mockup {
        height: 800px;
        object-position: right;
        object-fit: contain;
        object-position: bottom;
    }

    #bottom-wave {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 0;
    }

    .stores {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 16px;
        margin-top: 48px;
    }

    .stores img {
        height: 48px;
    }

    img.waves {
        width: 100vw;
    }

    .mobile-only {
        display: none;
    }

    @media (max-width: 768px) {
        section {
            padding: 1rem;
            padding-top: 80px;
            padding-bottom: 0px;
        }

        .row {
            flex-direction: column;
            align-items: center;
        }

        .col {
            flex-direction: column;
        }

        .stores {
            flex-direction: column;
            gap: 8px;
        }

        #mockup {
            width: 100%;
            height: auto;
        }

        .desktop-only {
            display: none;
        }

        .mobile-only {
            display: block;
        }

        #bottom-wave {
            z-index: 0;
        }

        .col.mockup {
            align-items: center;
            margin-bottom: 0px;
        }
    }
</style>